
// This file is maintained for backward compatibility
// It re-exports the contentful service from the new modular structure
import contentfulService from './contentful';

// Add the searchStories function if it doesn't exist in the imported service
const enhancedContentfulService = {
  ...contentfulService,
  // Add searchStories if it doesn't already exist in the imported service
  searchStories: async (query: string) => {
    const stories = await contentfulService.getStories();
    if (!query) return stories;
    
    const lowerQuery = query.toLowerCase();
    return stories.filter((story: any) => 
      story.title?.toLowerCase().includes(lowerQuery) || 
      story.excerpt?.toLowerCase().includes(lowerQuery) ||
      story.content?.toLowerCase().includes(lowerQuery) ||
      story.author?.name?.toLowerCase().includes(lowerQuery) ||
      story.category?.toLowerCase().includes(lowerQuery) ||
      (Array.isArray(story.tags) && story.tags.some((tag: string) => 
        tag.toLowerCase().includes(lowerQuery)
      ))
    );
  }
};

export default enhancedContentfulService;
